import { i18n } from "@/plugins/i18n";

export class ExpenseReport {
  columns = [];
  id = "id";

  fillAbles = [
    ["name", i18n.t("name"), true],
    ["expenseCount", i18n.t("expenseCount"), true],
    ["mcTotal", i18n.t("mcTotal"), true],
    ["scTotal", i18n.t("scTotal"), true, false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility:
          process.env.VUE_APP_PROJECT_NAME === "MassHills" ? false : true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
